/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Review_Spamdetected1Inputs */

const id_forms_review_spamdetected1 = /** @type {(inputs: Forms_Review_Spamdetected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spam terdeteksi`)
};

const ms_forms_review_spamdetected1 = /** @type {(inputs: Forms_Review_Spamdetected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spam dikesan`)
};

const da_forms_review_spamdetected1 = /** @type {(inputs: Forms_Review_Spamdetected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spam opdaget`)
};

const de_forms_review_spamdetected1 = /** @type {(inputs: Forms_Review_Spamdetected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spam erkannt`)
};

const en_us2_forms_review_spamdetected1 = /** @type {(inputs: Forms_Review_Spamdetected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spam detected`)
};

const es_es2_forms_review_spamdetected1 = /** @type {(inputs: Forms_Review_Spamdetected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spam detectado`)
};

const es_mx2_forms_review_spamdetected1 = /** @type {(inputs: Forms_Review_Spamdetected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spam detectado`)
};

const fil_forms_review_spamdetected1 = /** @type {(inputs: Forms_Review_Spamdetected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Natukoy ang spam`)
};

const fr_forms_review_spamdetected1 = /** @type {(inputs: Forms_Review_Spamdetected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spam détecté`)
};

const it_forms_review_spamdetected1 = /** @type {(inputs: Forms_Review_Spamdetected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rilevato spam`)
};

const hu_forms_review_spamdetected1 = /** @type {(inputs: Forms_Review_Spamdetected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spam észlelve`)
};

const nl_forms_review_spamdetected1 = /** @type {(inputs: Forms_Review_Spamdetected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spam gedetecteerd`)
};

const no_forms_review_spamdetected1 = /** @type {(inputs: Forms_Review_Spamdetected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spam oppdaget`)
};

const pl_forms_review_spamdetected1 = /** @type {(inputs: Forms_Review_Spamdetected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wykryto spam`)
};

const pt_br2_forms_review_spamdetected1 = /** @type {(inputs: Forms_Review_Spamdetected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spam detected`)
};

const pt_forms_review_spamdetected1 = /** @type {(inputs: Forms_Review_Spamdetected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spam detetado`)
};

const ro_forms_review_spamdetected1 = /** @type {(inputs: Forms_Review_Spamdetected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spam detectat`)
};

const fi_forms_review_spamdetected1 = /** @type {(inputs: Forms_Review_Spamdetected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roskaposti havaittu`)
};

const sv_forms_review_spamdetected1 = /** @type {(inputs: Forms_Review_Spamdetected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spam upptäckt`)
};

const vi_forms_review_spamdetected1 = /** @type {(inputs: Forms_Review_Spamdetected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã phát hiện spam`)
};

const tr_forms_review_spamdetected1 = /** @type {(inputs: Forms_Review_Spamdetected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spam tespit edildi`)
};

const cs_forms_review_spamdetected1 = /** @type {(inputs: Forms_Review_Spamdetected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detekován spam`)
};

const bg_forms_review_spamdetected1 = /** @type {(inputs: Forms_Review_Spamdetected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открит е спам`)
};

const ru_forms_review_spamdetected1 = /** @type {(inputs: Forms_Review_Spamdetected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обнаружен спам`)
};

const uk_forms_review_spamdetected1 = /** @type {(inputs: Forms_Review_Spamdetected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Виявлено спам`)
};

const ar_forms_review_spamdetected1 = /** @type {(inputs: Forms_Review_Spamdetected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم اكتشاف بريد عشوائي`)
};

const hi_forms_review_spamdetected1 = /** @type {(inputs: Forms_Review_Spamdetected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्पैम का पता चला`)
};

const th_forms_review_spamdetected1 = /** @type {(inputs: Forms_Review_Spamdetected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตรวจพบสแปม`)
};

const ja_forms_review_spamdetected1 = /** @type {(inputs: Forms_Review_Spamdetected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スパムが検出されました`)
};

const zh_cn2_forms_review_spamdetected1 = /** @type {(inputs: Forms_Review_Spamdetected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spam detected`)
};

const zh_hant1_forms_review_spamdetected1 = /** @type {(inputs: Forms_Review_Spamdetected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spam detected`)
};

const ko_forms_review_spamdetected1 = /** @type {(inputs: Forms_Review_Spamdetected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spam detected`)
};

/**
* | output |
* | --- |
* | "Spam detected" |
*
* @param {Forms_Review_Spamdetected1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_review_spamdetected1 = /** @type {((inputs?: Forms_Review_Spamdetected1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Review_Spamdetected1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_review_spamdetected1(inputs)
	if (locale === "ms") return ms_forms_review_spamdetected1(inputs)
	if (locale === "da") return da_forms_review_spamdetected1(inputs)
	if (locale === "de") return de_forms_review_spamdetected1(inputs)
	if (locale === "en-US") return en_us2_forms_review_spamdetected1(inputs)
	if (locale === "es-ES") return es_es2_forms_review_spamdetected1(inputs)
	if (locale === "es-MX") return es_mx2_forms_review_spamdetected1(inputs)
	if (locale === "fil") return fil_forms_review_spamdetected1(inputs)
	if (locale === "fr") return fr_forms_review_spamdetected1(inputs)
	if (locale === "it") return it_forms_review_spamdetected1(inputs)
	if (locale === "hu") return hu_forms_review_spamdetected1(inputs)
	if (locale === "nl") return nl_forms_review_spamdetected1(inputs)
	if (locale === "no") return no_forms_review_spamdetected1(inputs)
	if (locale === "pl") return pl_forms_review_spamdetected1(inputs)
	if (locale === "pt-BR") return pt_br2_forms_review_spamdetected1(inputs)
	if (locale === "pt") return pt_forms_review_spamdetected1(inputs)
	if (locale === "ro") return ro_forms_review_spamdetected1(inputs)
	if (locale === "fi") return fi_forms_review_spamdetected1(inputs)
	if (locale === "sv") return sv_forms_review_spamdetected1(inputs)
	if (locale === "vi") return vi_forms_review_spamdetected1(inputs)
	if (locale === "tr") return tr_forms_review_spamdetected1(inputs)
	if (locale === "cs") return cs_forms_review_spamdetected1(inputs)
	if (locale === "bg") return bg_forms_review_spamdetected1(inputs)
	if (locale === "ru") return ru_forms_review_spamdetected1(inputs)
	if (locale === "uk") return uk_forms_review_spamdetected1(inputs)
	if (locale === "ar") return ar_forms_review_spamdetected1(inputs)
	if (locale === "hi") return hi_forms_review_spamdetected1(inputs)
	if (locale === "th") return th_forms_review_spamdetected1(inputs)
	if (locale === "ja") return ja_forms_review_spamdetected1(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_review_spamdetected1(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_review_spamdetected1(inputs)
	return ko_forms_review_spamdetected1(inputs)
});
export { forms_review_spamdetected1 as "forms.review.spamDetected" }